import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { initNative } from "./lib/native";
import Landing from "./pages/Landing";
import AuthPage from "./pages/AuthPage";
import Profiles from "./pages/Profiles";
import KidLayout from "./components/KidLayout";
import KidHome from "./pages/KidHome";
import Watch from "./pages/Watch";
import Studio from "./pages/Studio";
import MyVideos from "./pages/MyVideos";
import Creator from "./pages/Creator";
import Shorts from "./pages/Shorts";
import Games, { GamePlay } from "./pages/Games";
import StarShop from "./pages/StarShop";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import Legal from "./pages/Legal";
import ParentDashboard from "./pages/ParentDashboard";
import GoogleCallback from "./pages/GoogleCallback";
import GoogleConsent from "./pages/GoogleConsent";

const Loader = () => <div className="min-h-screen grid place-items-center font-display text-2xl">Loading Zunii…</div>;

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const NeedParent = ({ children }) => {
  const { parent } = useAuth();
  if (parent === null) return <Loader />;
  return parent ? children : <Navigate to="/login" replace />;
};

const NeedUnlocked = ({ children }) => {
  const { unlocked } = useAuth();
  return unlocked ? children : <Navigate to="/profiles" replace />;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <GoogleCallback />;
  return (
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/google-consent" element={<GoogleConsent />} />
            <Route path="/privacy" element={<Legal />} />
            <Route path="/terms" element={<Legal />} />
            <Route path="/safety" element={<Legal />} />
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/signup" element={<AuthPage mode="signup" />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/profiles" element={<NeedParent><Profiles /></NeedParent>} />
            <Route path="/parent" element={<NeedParent><NeedUnlocked><ParentDashboard /></NeedUnlocked></NeedParent>} />
            <Route path="/kid" element={<NeedParent><KidLayout /></NeedParent>}>
              <Route index element={<KidHome />} />
              <Route path="watch/:id" element={<Watch />} />
              <Route path="studio" element={<Studio />} />
              <Route path="mine" element={<MyVideos />} />
              <Route path="creator/:id" element={<Creator />} />
              <Route path="shorts" element={<Shorts />} />
              <Route path="games" element={<Games />} />
              <Route path="games/:game" element={<GamePlay />} />
              <Route path="shop" element={<StarShop />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
  );
}

function App() {
  useEffect(() => { initNative(); }, []);
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <AppRouter />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
